<template>
  <div class="wrapping">
    <b-row class="mt-4 main-content">
      <b-col sm="12" md="10" lg="10" offset-lg="1" offset-md="1">
        <h2 class="app_title">
          <span
            ><img :src="require(`../../assets/iridi_nest_logo.png`)" alt=""
          /></span>
          <span>iRidium для Nest</span>
        </h2>
        <p>
          Набор инструментов для создания интерфейсов управления оборудованием
          от производителей Nest.
          <br />
          <span class="glyphicon glyphicon-info-sign"></span> Драйвер только для
          серверного проекта.
        </p>

        <hr />
        <p>
          Пожалуйста, ознакомьтесь с нашей
          <router-link
            to="/policy/nest/privacy-policy-for-access-to-google-apis/ru"
            >политикой конфиденциальности для доступа к API Google</router-link
          >
          до использования iRidium для Nest
        </p>

        <div id=".D0.9E.D0.BF.D0.B8.D1.81.D0.B0.D0.BD.D0.B8.D0.B5"></div>
        <h1><span class="mw-headline" id="Описание"></span>Описание</h1>
        <p>
          iRidium для Nest - это набор инструментов, позволяющий создать
          интерфейс для управления оборудованием Nest. Облачный драйвер общается
          с оборудованием посредством HTTP запросов.
        </p>
        <p><br /></p>
        <div
          id=".D0.9F.D0.BE.D0.B4.D0.BA.D0.BB.D1.8E.D1.87.D0.B5.D0.BD.D0.B8.D0.B5"
        ></div>
        <h1><span class="mw-headline" id="Подключение"></span>Подключение</h1>
        <p>Для подключения к оборудованию Nest:</p>
        <p>
          <span class="label label-default"> 1</span> Настройте Google аккаунт
          на работу с оборудованием Nest.
        </p>
        <p>
          <span class="label label-default"> 2</span> Создайте облачный объект
          для вашего проекта iRidium Pro.
        </p>
        <p>
          <span class="label label-default"> 3</span> Перейдите по
          <a
            class="external text"
            href="https://cws.iridi.com/services/oauth/available"
            >ссылке</a
          >
          и авторизуйтесь под вашим аккаунтом iRidium.
        </p>
        <p>
          <span class="label label-default"> 4</span> Выберите
          <b>Connect</b> (Установить) для драйвера Nest.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="IR assistant nest connect.png"
                src="https://dev.iridi.com/images/e/ea/IR_assistant_nest_connect.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 5</span> Примите разрешение на
          просмотр и использование данных о вашем доме из приложения Google
          Home.
        </p>
        <p>
          <span class="label label-default"> 6</span> Выберите необходимый
          объект на облаке iRidium.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="IR assistant choose object.png"
                src="https://dev.iridi.com/images/7/7f/IR_assistant_choose_object.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 7</span> Нажмите
          <b>Link</b> (Связать). Обратите внимание, что сессия для связывания
          может истечь, в таком случае вы получите ошибку
          <b>invalid_grant / Bad Request</b>, следует вернуться к пункту 4 и
          повторить последующие шаги.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="IR assistant nest connect 2.png"
                src="https://dev.iridi.com/images/d/db/IR_assistant_nest_connect_2.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 8</span> Скачайте JS файл со
          структурой драйвера. Ниже мы можем видеть актуальный токен OAuth2.0
          для доступа к оборудованию. Этот токен заменяет обычную авторизацию.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Download json.png"
                src="https://dev.iridi.com/images/f/f6/Download_json.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 9</span>
          <a href="#Импорт_данных"> Импортируйте</a> скачанный JS файл в iRidium
          Studio.
        </p>
        <p>
          <span class="label label-default"> 10</span> Загрузите ваш проект с
          драйвером Nest на объект облака iRidium.
        </p>
        <p>
          <span style="color: red"
            ><span class="glyphicon glyphicon-info-sign"></span
          ></span>
          Так как драйвер облачный, он работает только при запуске проекта с
          облака.
        </p>
        <p><br /></p>
        <p><b>В случае, если токен авторизации стал неактуален: </b></p>
        <p>
          <span class="label label-default"> 1</span> Перейдите по
          <a
            class="external text"
            href="https://cws.iridi.com/services/oauth/available"
            >ссылке</a
          >.
        </p>
        <p>
          <span class="label label-default"> 2</span> Нажмите
          <b>Issued tokens</b> (Выданные токены).
        </p>
        <p>
          <span class="label label-default"> 3</span> Выберите объект i3pro с
          привязанным аккаунтом Google и Nest оборудованием.
        </p>
        <p>
          <span class="label label-default"> 4</span> Синхронизируйте токен и
          нажмите <b>Devices and structures</b> (Устройства и структура).
        </p>
        <p>
          <span class="label label-default"> 5</span> Скопируйте токен доступа.
        </p>
        <p>
          <span class="label label-default"> 6</span> Можете обновить токен в
          проекте через настройки драйвера в iRidium Studio (после этого
          необходимо обновить проект на облаке) или ввести новый токен в
          настройках устройств в веб-интерфейсе сервера.
        </p>
        <p><br /></p>
        <div id=".D0.A0.D0.B0.D0.B1.D0.BE.D1.82.D0.B0_.D0.B2_iRidium"></div>
        <h1>
          <span class="mw-headline" id="Работа_в_iRidium"></span>Работа в
          iRidium
        </h1>
        <p>
          Создайте новый проект и добавьте драйвер <b>Nest Network</b> с помощью
          импорта или ручным вводом данных.
        </p>
        <div
          id=".D0.98.D0.BC.D0.BF.D0.BE.D1.80.D1.82_.D0.B4.D0.B0.D0.BD.D0.BD.D1.8B.D1.85"
        ></div>
        <h2>
          <span class="mw-headline" id="Импорт_данных"></span>Импорт данных
        </h2>
        <p>
          Чтобы импортировать команды и каналы обратной связи оборудования из JS
          проекта:
        </p>
        <p>
          <span class="label label-default"> 1</span> Запустите iRidium studio,
          создайте проект и откройте боковую панель <b>Devices</b>.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Nest1.png"
                src="https://dev.iridi.com/images/5/5e/Nest1.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 2</span> Во вкладке
          <b>Scanner / Import</b> выберите
          <b>Universal import from JS (*.js, *.json)</b> и откройте файл
          проекта.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Nest2.png"
                src="https://dev.iridi.com/images/4/4f/Nest2.png"
              />
            </div>
          </div>
        </div>
        <br />
        <br />
        <h2>
          <span class="mw-headline" id="Добавление_драйвера_вручную"></span
          >Добавление драйвера вручную
        </h2>
        <p>
          <span class="label label-default">1</span> В созданном проекте на
          вкладке <b>Devices</b> добавьте драйвер <b>Nest Network</b>:
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Nest3.png"
                src="https://dev.iridi.com/images/7/71/Nest3.png"
              />
            </div>
          </div>
        </div>
        <br />
        <p>
          <span class="label label-default">2</span> Нажатием ЛКМ по драйверу
          добавьте подустройство (<b>Add subdevice</b>) и укажите настройки
          подключения драйвера:
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Nest4.png"
                src="https://dev.iridi.com/images/c/cd/Nest4.png"
              />
            </div>
            <ul>
              <li><b>Log Level</b> - уровень логирования;</li>
              <li>
                <b>Token</b> - токен авторизации OAuth2.0 (подставляется
                автоматически при импорте).
              </li>
              <li><b>Driver Version</b> - версия драйвера.</li>
            </ul>
          </div>
          <div class="row">
            <div>
              <div class="thumbnail">
                <b-img
                  fluid
                  alt="Nest5.png"
                  src="https://dev.iridi.com/images/f/fa/Nest5.png"
                />
              </div>
              <ul>
                <li><b>Name</b> - имя подустройства;</li>
                <li><b>Driver Type</b> - тип драйвера;</li>
                <li><b>Subdevice ID</b> - идентификатор подустройства;</li>
                <li><b>Device Type</b> - тип подустройства.</li>
              </ul>
            </div>
          </div>
        </div>
        <br />
        <br />
        <h2><span class="mw-headline" id="Устройства"></span>Устройства</h2>
        <p>
          У команд и фидбеков устройств Nest нет специфических настроек. Они
          заранее фиксировано создаются при добавлении устройства. Управление
          оборудованием происходит посредством отправки <i>value</i> в команду
          (Send number, Send string, send value from object).
        </p>
        <br />
        <br />
        <h3><span class="mw-headline" id="Thermostat"></span>Thermostat</h3>
        <p><big>Command</big>:</p>
        <table class="table">
          <tr>
            <td><b>Команда / фидбек</b></td>
            <td><b>Входные / ожидаемые значения</b></td>
            <td><b>Описание</b></td>
          </tr>
          <tr>
            <td>Mode Off</td>
            <td>Value</td>
            <td>Выбор режима - выключить.</td>
          </tr>
          <tr>
            <td>Heat</td>
            <td>Value</td>
            <td>Выбор режима - нагрев.</td>
          </tr>
          <tr>
            <td>Cool</td>
            <td>Value</td>
            <td>Выбор режима - охлаждение.</td>
          </tr>
          <tr>
            <td>HeatCool</td>
            <td>Value</td>
            <td>Выбор режима - нагрев-охлаждение.</td>
          </tr>
          <tr>
            <td>Heat Temperature</td>
            <td>9~32</td>
            <td>Целевая температура нагрева.</td>
          </tr>
          <tr>
            <td>Cool Temperature</td>
            <td>9~32</td>
            <td>Целевая температура охлаждения.</td>
          </tr>
          <tr>
            <td>HeatCool Low Temperature</td>
            <td>9~32</td>
            <td>Нижний температурный предел для режима нагрев-охлаждение.</td>
          </tr>
          <tr>
            <td>HeatCool High Temperature</td>
            <td>9~32</td>
            <td>Верхний температурный предел для режима нагрев-охлаждение.</td>
          </tr>
          <tr>
            <td>Eco Mode On</td>
            <td>Value</td>
            <td>Включить режим эко.</td>
          </tr>
          <tr>
            <td>Eco Mode Off</td>
            <td>Value</td>
            <td>Выключить режим эко.</td>
          </tr>
          <tr>
            <td>Fan Timer On</td>
            <td>Value</td>
            <td>Включить вентиляцию на срок в минутах.</td>
          </tr>
          <tr>
            <td>Fan Timer Off</td>
            <td>Value</td>
            <td>Отключить вентиляцию.</td>
          </tr>
        </table>
        <br />
        <br />
        <p>
          <br />
          <big>Feedback</big>:
        </p>
        <table class="table">
          <tr>
            <td><b>Команда / фидбек</b></td>
            <td><b>Входные / ожидаемые значения</b></td>
            <td><b>Описание</b></td>
          </tr>
          <tr>
            <td>Mode</td>
            <td>
              Off, <br />
              Heat, <br />
              Cool, <br />
              HeatCool.
            </td>
            <td>Текущий режим.</td>
          </tr>
          <tr>
            <td>HVAC</td>
            <td>
              "OFF", <br />
              "HEATING", <br />
              "COOLING".
            </td>
            <td>Текущее состояние работы устройства.</td>
          </tr>
          <tr>
            <td>Eco Mode</td>
            <td>0-1</td>
            <td>
              Текущий режим эко: <br />
              1 - режим manual eco, 0 - выключен.
            </td>
          </tr>
          <tr>
            <td>Eco Heat</td>
            <td>Value</td>
            <td>
              Температура, при которой будет работать обогрев в режиме эко.
            </td>
          </tr>
          <tr>
            <td>Eco Cool</td>
            <td>Value</td>
            <td>
              Температура, при которой будет работать охлаждение в режиме эко.
            </td>
          </tr>
          <tr>
            <td>Temperature Heat</td>
            <td>9~32</td>
            <td>Текущая целевая температура нагрева.</td>
          </tr>
          <tr>
            <td>Temperature Cool</td>
            <td>9~32</td>
            <td>Текущая целевая температура охлаждения.</td>
          </tr>
          <tr>
            <td>Temperature HeatCool High</td>
            <td>9~32</td>
            <td>
              Текущий заданный верхний температурный предел для режима
              нагрев-охлаждение.
            </td>
          </tr>
          <tr>
            <td>Temperature HeatCool Low</td>
            <td>9~32</td>
            <td>
              Текущий заданный нижний температурный предел для режима
              нагрев-охлаждение.
            </td>
          </tr>
          <tr>
            <td>Connectivity</td>
            <td>0-1</td>
            <td>
              Подключение термостата: <br />
              1 - включен, 0 - выключен.
            </td>
          </tr>
          <tr>
            <td>Fan Mode</td>
            <td>"on / off"</td>
            <td>
              Текущее состояние вентиляции: <br />
              on - включена, off - выключена.
            </td>
          </tr>
          <tr>
            <td>Fan Timer Timeout</td>
            <td>Value</td>
            <td>Время истечения таймера работы вентилирования.</td>
          </tr>
          <tr>
            <td>Humidity</td>
            <td>0~100</td>
            <td>Текущая влажность (%).</td>
          </tr>
          <tr>
            <td>Info</td>
            <td>"Thermostat"</td>
            <td>Имя устройства в приложении Nest.</td>
          </tr>
          <tr>
            <td>Settings</td>
            <td>"CELSIUS"</td>
            <td>
              Единица измерения температуры: <br />
              CELSIUS - цельсии, FAHRENHEIT - фаренгейты.
            </td>
          </tr>
          <tr>
            <td>Ambient Temperature</td>
            <td>Value</td>
            <td>Текущая температура.</td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <div class="text-center" style="width: 100%">
        <br />
        <br />
        <router-link
          to="/policy/nest/privacy-policy-for-access-to-google-apis/ru"
          >Политика конфиденциальности для доступа к API Google</router-link
        >
        <br />
        <br />
      </div>
    </b-row>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.app_title {
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    display: inline-block;
    img {
      width: 60px;
      height: 60px;
    }

    &:nth-child(2) {
      margin-left: 10px;
    }
  }
}
.label {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}

a.label:hover,
a.label:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}

.label:empty {
  display: none;
}

.btn .label {
  position: relative;
  top: -1px;
}

.label-default {
  background-color: #999999;
}

.label-default[href]:hover,
.label-default[href]:focus {
  background-color: #808080;
}

.label-primary {
  background-color: #1c75bc;
}

.label-primary[href]:hover,
.label-primary[href]:focus {
  background-color: #0c7cd5;
}

.label-success {
  background-color: #4caf50;
}

.label-success[href]:hover,
.label-success[href]:focus {
  background-color: #3d8b40;
}

.label-info {
  background-color: #00bcd4;
}

.label-info[href]:hover,
.label-info[href]:focus {
  background-color: #008fa1;
}

.label-warning {
  background-color: #ff5722;
}

.label-warning[href]:hover,
.label-warning[href]:focus {
  background-color: #ee3900;
}

.label-danger {
  background-color: #f44336;
}

.label-danger[href]:hover,
.label-danger[href]:focus {
  background-color: #ea1c0d;
}
</style>
